import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { IResult } from '../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtSiteSettings } from '../../../../types/ISiteSettingsForSiteAdmin';

export type IGetAnalyticsExtSiteSettingsResult = IResult & IAnalyticsExtSiteSettings;

export class GetAnalyticsExtSiteSettingsRequest extends TagRequest<{}, IGetAnalyticsExtSiteSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsSiteSettings', {});
  }
}
